import {
    DelegationCreateTxParams,
    DelegationDeleteTxParams,
    DelegationDepositTxParams,
    DelegationUpdateMinADATxParams,
    DelegationWithdrawTxParams,
    toJson,
    WalletTxParams,
} from '../../Commons';
import { DelegationEntity } from '../../Entities/Delegation.Entity';
import { fetchWrapper } from '../../lib/index.exports';
import { SmartDBTxApiCalls } from '../index.exports.BtnHandlers.TxApiCalls';

export class DelegationTxApiCalls extends SmartDBTxApiCalls {
    protected static _Entity = DelegationEntity;

    // #region api tx

    public static async createTxApi(walletTxParams: WalletTxParams, txParams: DelegationCreateTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `DelegationCreateTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - createTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - createTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async depositTxApi(walletTxParams: WalletTxParams, txParams: DelegationDepositTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `DelegationDepositTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/deposit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - depositTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - depositTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async withdrawTxApi(walletTxParams: WalletTxParams, txParams: DelegationWithdrawTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `DelegationWithdrawTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/withdraw`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - withdrawTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - withdrawTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async updateMinADATxApi(walletTxParams: WalletTxParams, txParams: DelegationUpdateMinADATxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `DelegationUpdateMinADATxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/update-min-ada`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - updateMinADATxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - updateMinADATxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async deleteTxApi(walletTxParams: WalletTxParams, txParams: DelegationDeleteTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `DelegationDeleteTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - deleteTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - deleteTxApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api tx
}
